import React from 'react';

import { Text } from '@companycam/slab-web';
import styled from 'styled-components';
import { translate } from 'javascripts/translations/i18n';

// #region styled-components

const IconContainer = styled.div`
  border-radius: var(--cc_size_border_radius_xxl);
  border: var(--cc_size_border_width_m) solid var(--cc_color_brand_secondary);
  min-width: 40px;
  height: 40px;
  margin-right: var(--cc_size_spacing_m);
  align-content: center;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: var(--cc_color_background_2);
`;

const Icon = styled.i`
  font-size: var(--cc_size_text_xl);
  color: var(--cc_color_brand_secondary);
`;

const TimelineTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TimelineContainer = styled.div`
  justify-content: flex-start;
  margin-bottom: var(--cc_size_spacing_xl);
`;

const TimelineEvent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const VerticalLine = styled.div`
  margin-left: 19px;
  margin-top: -10px;
  margin-bottom: -10px;
  background-color: var(--cc_color_brand_secondary);
  width: var(--cc_size_border_width_m);
  height: 48px;
`;
// #endregion styled-components

type TimelineProps = {
  timelineSubHeaderOne: string;
  timelineSubHeaderTwo: string;
  timelineSubHeaderThree: string;
};

function Timeline({
  timelineSubHeaderOne,
  timelineSubHeaderTwo,
  timelineSubHeaderThree,
}: TimelineProps) {
  return (
    <TimelineContainer>
      <TimelineEvent>
        <IconContainer>
          <Icon className="mdi mdi-gift-outline" />
        </IconContainer>
        <TimelineTextContainer>
          <Text
            as="p"
            size="s"
            color="default"
            family="heading"
            weight={700}
            ccMargin="none none xs none"
          >
            {translate('billing.stripePaymentModal.timeline.timelineHeaderOne')}
          </Text>
          <Text as="p" size="xs" color="subtle" family="heading" weight={400}>
            {timelineSubHeaderOne}
          </Text>
        </TimelineTextContainer>
      </TimelineEvent>
      <VerticalLine />
      <TimelineEvent>
        <IconContainer>
          <Icon className="mdi mdi-bell-outline" />
        </IconContainer>
        <TimelineTextContainer>
          <Text
            as="p"
            size="s"
            color="default"
            family="heading"
            weight={700}
            ccMargin="none none xs none"
            data-testid="choosePlans__trial-minus-two"
          >
            {translate('billing.stripePaymentModal.timeline.timelineHeaderTwo')}
          </Text>
          <Text as="p" size="xs" color="subtle" family="heading" weight={400}>
            {timelineSubHeaderTwo}
          </Text>
        </TimelineTextContainer>
      </TimelineEvent>
      <VerticalLine />
      <TimelineEvent>
        <IconContainer>
          <Icon className="mdi mdi-lightning-bolt" />
        </IconContainer>
        <TimelineTextContainer>
          <Text
            as="p"
            size="s"
            color="default"
            family="heading"
            weight={700}
            ccMargin="none none xs none"
            data-testid="choosePlans__trial-end"
          >
            {translate(
              'billing.stripePaymentModal.timeline.timelineHeaderThree',
            )}
          </Text>

          <Text as="p" size="xs" color="subtle" family="heading" weight={400}>
            {timelineSubHeaderThree}
          </Text>
        </TimelineTextContainer>
      </TimelineEvent>
    </TimelineContainer>
  );
}

export default Timeline;
